import { RUNTIME_BACKEND_URL } from '../../lib/backendUrl';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Globe, Loader2, CheckCircle2 } from 'lucide-react';
import { useHesapAuth } from '../../store/hesapStore';
import { useHesapBranding } from '../../store/hesapBrandingStore';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { GeneralTab } from '../../components/hesap/site-settings/GeneralTab';
import { AnnouncementsTab } from '../../components/hesap/site-settings/AnnouncementsTab';
import { LandingTab } from '../../components/hesap/site-settings/LandingTab';
import { AdsTab } from '../../components/hesap/site-settings/AdsTab';
import { StorageTab } from '../../components/hesap/site-settings/StorageTab';
import { hesapPrefix } from '../../lib/subdomain';

const API = `${RUNTIME_BACKEND_URL}/api/hesap`;
const SAVE_TABS = ['genel', 'duyurular', 'tanitim', 'reklamlar'];

export default function HesapSiteSettingsPage() {
  const { token, user } = useHesapAuth();
  const [value, setValue] = useState(null);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('genel');

  useEffect(() => {
    fetch(`${API}/site-settings`).then(r => r.json()).then(setValue).catch(() => toast.error('Ayarlar yüklenemedi'));
    // Kaydedilmeden çıkılırsa renk önizlemesini geri al
    return () => { useHesapBranding.getState().load(); };
  }, []);

  if (user?.role !== 'admin') return <Navigate to={hesapPrefix() || '/'} replace />;

  const save = async () => {
    setSaving(true);
    try {
      const r = await fetch(`${API}/site-settings`, {
        method: 'PUT', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(value),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || 'Kaydedilemedi');
      setValue(d);
      await useHesapBranding.getState().load();
      toast.success('Site ayarları kaydedildi');
    } catch (e) { toast.error(e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-5" data-testid="hesap-site-settings-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="p-2.5 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 text-white shadow-md"><Globe className="h-6 w-6" /></div>
          <div>
            <h1 className="text-2xl font-bold">Site Ayarları</h1>
            <p className="text-sm text-slate-500">Marka, tanıtım sayfası, reklamlar ve alan kullanımı</p>
          </div>
        </div>
        {SAVE_TABS.includes(tab) && value && (
          <Button onClick={save} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700" data-testid="save-site-settings-btn">
            {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <CheckCircle2 className="h-4 w-4 mr-2" />} Kaydet
          </Button>
        )}
      </div>

      {!value ? (
        <div className="py-16 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>
      ) : (
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="flex flex-wrap h-auto">
            <TabsTrigger value="genel" data-testid="site-tab-genel">Genel & Marka</TabsTrigger>
            <TabsTrigger value="duyurular" data-testid="site-tab-duyurular">Duyurular</TabsTrigger>
            <TabsTrigger value="tanitim" data-testid="site-tab-tanitim">Tanıtım & İletişim</TabsTrigger>
            <TabsTrigger value="reklamlar" data-testid="site-tab-reklamlar">Reklamlar</TabsTrigger>
            <TabsTrigger value="alan" data-testid="site-tab-alan">Alan Kullanımı</TabsTrigger>
          </TabsList>
          <Card className="mt-3">
            <CardContent className="p-5">
              <TabsContent value="genel" className="mt-0"><GeneralTab value={value} onChange={setValue} token={token} /></TabsContent>
              <TabsContent value="duyurular" className="mt-0"><AnnouncementsTab value={value} onChange={setValue} /></TabsContent>
              <TabsContent value="tanitim" className="mt-0"><LandingTab value={value} onChange={setValue} /></TabsContent>
              <TabsContent value="reklamlar" className="mt-0"><AdsTab value={value} onChange={setValue} token={token} /></TabsContent>
              <TabsContent value="alan" className="mt-0"><StorageTab token={token} /></TabsContent>
            </CardContent>
          </Card>
        </Tabs>
      )}
    </div>
  );
}
